function EnterConfirmPrivacy(){
	var id = 'enterConfirmPrivacy';

}
 
// EnterConfirmPrivacy.prototype = new WhistlePage();

new EnterConfirmPrivacy()